import { Button } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { DataTokenCard } from '../Token';
import { DataTokenType } from '../../types';
export default function DataTokenSection() {
    var aggregate = useField('aggregate', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    var name = useMemo(function () {
        if (aggregate) {
            return 'dataAggregate';
        }
        else {
            return 'data';
        }
    }, [aggregate]);
    return (React.createElement(FieldArray, { key: name, name: name }, function (_a) {
        var fields = _a.fields;
        return (React.createElement(React.Fragment, null,
            fields.map(function (innerName, index) { return (React.createElement(DataTokenCard, { key: innerName, name: innerName, index: index, isLast: index + 1 === fields.length })); }),
            React.createElement(Button, { onClick: function () { return fields.push({ type: DataTokenType.NEWLINE }); } },
                React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.add" }))));
    }));
}
